import React, { FC } from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../../constants/aampeTheme';

interface ChannelInfo {
    channel: string;
    percentage: number;
    color: string;
}

interface ProgressBarProps {
    channels: ChannelInfo[];
}

const MessagesProgressBar: FC<React.PropsWithChildren<ProgressBarProps>> = ({
    channels,
}) => {
    const validChannels = channels.filter(
        (channel) => channel.percentage !== 0,
    );
    return (
        <ProgressBarContainer>
            {validChannels.map((channel, index) => (
                <ProgressBarSegment
                    key={index}
                    style={{
                        width: `${channel.percentage}%`,
                        backgroundColor: channel.color,
                    }}
                />
            ))}
        </ProgressBarContainer>
    );
};
export default MessagesProgressBar;

const ProgressBarContainer = styled.div({
    height: '8px',
    width: '100%',
    backgroundColor: aampeTheme.colors.neutral09,
    borderRadius: aampeTheme.borderRadius.default,
    display: 'flex',
});

const ProgressBarSegment = styled.div({
    ':first-child': {
        borderTopLeftRadius: aampeTheme.borderRadius.default,
        borderBottomLeftRadius: aampeTheme.borderRadius.default,
    },
    ':last-child': {
        borderTopRightRadius: aampeTheme.borderRadius.default,
        borderBottomRightRadius: aampeTheme.borderRadius.default,
    },
});
